import { render, staticRenderFns } from "./RecaptchaComponent.vue?vue&type=template&id=fb9f89cc&scoped=true&"
import script from "./RecaptchaComponent.vue?vue&type=script&lang=tsx&"
export * from "./RecaptchaComponent.vue?vue&type=script&lang=tsx&"
import style0 from "./RecaptchaComponent.vue?vue&type=style&index=0&id=fb9f89cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9f89cc",
  null
  
)

export default component.exports